import SliderBase from './base-slider';

class BrandSliderHandler extends SliderBase {

}

export default ( $scope ) => {
	elementorFrontend.elementsHandler.addHandler( BrandSliderHandler, { $element: $scope } );
};
